import React from 'react'
import MaterialSymbol from '../material-symbol'

const Cancel = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="cancel" {...props} />
))

Cancel.displayName = 'Cancel'

export default Cancel
